import { useActiveTab, useAppFilters } from '@/hooks';
import { ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';
import { useMemo } from 'react';
import { sortComponentsByHealthStatusAndName } from './util';

export function useComponentList(
  components: any,
  maintenanceCounters?: { total: number; components: any },
  asset?: any
) {
  const { assetStudio } = useAppFilters();
  const { isVisualAI, isMaintenance, isDiagnostics, isSensorData, isAlarms } = useActiveTab();

  const componentsList = useMemo(() => {
    const sortedItems = sortComponentsByHealthStatusAndName(components);
    const tmp =
      sortedItems?.map((el: any) => {
        // Check if this component has camera or oil sensors from asset data
        const camera_components =
          asset?.camera_components?.filter((cam: any) => cam.component_id === el.component_id) || [];
        const oil_reported_components =
          asset?.oil_reported_components?.filter((oil: any) => oil.component_id === el.component_id) || [];

        return {
          id: el.component_id,
          name: el.component_ui_name || el.component_name,
          camera_components,
          oil_reported_components,
          ...el,
        };
      }) || [];

    const baseMenuItems = [
      {
        id: ASSET_STUDIO.ALL_COMPONENTS,
        name: isMaintenance || isAlarms ? 'All Components' : 'Asset Overview',
        counter: isMaintenance ? maintenanceCounters?.total : components?.length || 0,
        disabled: isSensorData || isVisualAI,
        hideCounter: !isMaintenance,
      },
      {
        id: ASSET_STUDIO.UNASSIGNED,
        name: 'Unassigned',
        counter: maintenanceCounters?.components?.['null'],
      },
      ...tmp.map((el: any) => {
        // Keep the camera_components and oil_reported_components from tmp
        return { ...el, counter: maintenanceCounters?.components?.[el.id], hideCounter: !isMaintenance };
      }),
    ];

    const units = Array.from(new Set(tmp.map((el: any) => el.unit_ui_name))).filter((el) => !!el);

    return {
      components: [
        {
          menuLabel: 'components',
          menuItems: baseMenuItems.filter((el) => {
            return (
              ((isDiagnostics || isSensorData || isVisualAI || isAlarms) && el.id !== ASSET_STUDIO.UNASSIGNED) ||
              (isMaintenance
                ? el.id !== ASSET_STUDIO.UNASSIGNED || el.counter > 0
                : el.id !== ASSET_STUDIO.ALL_COMPONENTS && el.id !== ASSET_STUDIO.UNASSIGNED)
            );
          }),
        },
      ],
      units,
    };
  }, [components, assetStudio, maintenanceCounters, asset]);
  return { componentsList };
}
